import { Form, Spinner } from "react-bootstrap";

import { useGroups } from "../../hooks/useGroups";

import { compareGroupNames } from "./groupOrder";

interface GroupPickerProps {
  selected: string[];
  onChange: (groups: string[]) => void;
  disabled?: boolean;
  idPrefix?: string;
  lockedGroups?: string[];
  lockedGroupReason?: string;
}

const GroupPicker: React.FC<GroupPickerProps> = ({
  selected,
  onChange,
  disabled,
  idPrefix = "group-picker",
  lockedGroups = [],
  lockedGroupReason,
}) => {
  const { groups, loading, error } = useGroups();

  const toggleGroup = (groupName: string, checked: boolean) => {
    if (checked) {
      onChange([...selected, groupName]);
    } else {
      onChange(selected.filter((g) => g !== groupName));
    }
  };

  if (loading) return <Spinner animation="border" size="sm" />;
  if (error) return <p className="text-danger">{error}</p>;

  const sortedGroups = [...groups].sort((a, b) => compareGroupNames(a.group_name, b.group_name));

  return (
    <div className="group-picker">
      {sortedGroups.map((group) => {
        const isLocked = lockedGroups.includes(group.group_name);
        return (
          <Form.Check
            key={group.group_name}
            type="checkbox"
            id={`${idPrefix}-${group.group_name}`}
            label={group.group_name}
            title={isLocked ? lockedGroupReason : (group.description ?? undefined)}
            checked={selected.includes(group.group_name)}
            disabled={disabled === true || isLocked}
            onChange={(e) => {
              toggleGroup(group.group_name, e.target.checked);
            }}
          />
        );
      })}
    </div>
  );
};

export default GroupPicker;
